// extracted by mini-css-extract-plugin
module.exports = {"icon":"Toast_icon__2sjrO","Toast":"Toast_Toast__2hgL4"};